/*=========================================================================================
    File Name: card-statistics.js
    Description: Card-statistics page content with Apexchart Examples
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: PIXINVENT
    Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

$(window).on("load", function () {

    var $primary = '#7367F0';
    var $success = '#28C76F';
    var $danger = '#EA5455';
    var $warning = '#FF9F43';
    var $primary_light = '#A9A2F6';
    var $success_light = '#55DD92';
    var $warning_light = '#ffc085';

    // Subscribed Gained Chart
    // ----------------------------------

    if (document.querySelector("#line-area-chart-1")){
        var gainedChartoptions = {
            chart: {
                height: 100,
                type: 'area',
                toolbar: {
                    show: false,
                },
                sparkline: {
                    enabled: true
                },
                grid: {
                    show: false,
                    padding: {
                        left: 0,
                        right: 0
                    }
                },
            },
            colors: [$primary],
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth',
                width: 2.5
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shadeIntensity: 0.9,
                    opacityFrom: 0.7,
                    opacityTo: 0.5,
                    stops: [0, 80, 100]
                }
            },
            series: [{
                name: 'Subscribers',
                data: [28, 40, 36, 52, 38, 60, 55]
            }],

            xaxis: {
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                }
            },
            yaxis: [{
                y: 0,
                offsetX: 0,
                offsetY: 0,
                padding: {left: 0, right: 0},
            }],
            tooltip: {
                x: {show: false}
            },
        }

        var gainedChart = new ApexCharts(
            document.querySelector("#line-area-chart-1"),
            gainedChartoptions
        );

        gainedChart.render();
    }



    // Revenue Generated Chart
    // ----------------------------------

    if (document.querySelector("#line-area-chart-2")){
        var revenueChartoptions = {
            chart: {
                height: 100,
                type: 'area',
                toolbar: {
                    show: false,
                },
                sparkline: {
                    enabled: true
                },
                grid: {
                    show: false,
                    padding: {
                        left: 0,
                        right: 0
                    }
                },
            },
            colors: [$success],
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth',
                width: 2.5
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shadeIntensity: 0.9,
                    opacityFrom: 0.7,
                    opacityTo: 0.5,
                    stops: [0, 80, 100]
                }
            },
            series: [{
                name: $('[data-total_payment_waiting_payment_label]').text(),
                data: [0, 0, 0, 0, 0, 0, 0]
            }],

            xaxis: {
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                }
            },
            yaxis: [{
                y: 0,
                offsetX: 0,
                offsetY: 0,
                padding: {left: 0, right: 0},
            }],
            tooltip: {
                x: {show: false}
            },
        }

        var revenueChart = new ApexCharts(
            document.querySelector("#line-area-chart-2"),
            revenueChartoptions
        );

        revenueChart.render();

        if ($('#line-area-chart-2').length) {
            fillChart(revenueChart, $('#line-area-chart-2'), $('[data-total_payment_waiting_payment]'), $('[data-total_payment_waiting_payment_label]').text())
        }
    }


    // Quaterly Sales Chart
    // ----------------------------------
    if (document.querySelector("#line-area-chart-3")){
        var salesChartoptions = {
            chart: {
                height: 100,
                type: 'area',
                toolbar: {
                    show: false,
                },
                sparkline: {
                    enabled: true
                },
                grid: {
                    show: false,
                    padding: {
                        left: 0,
                        right: 0
                    }
                },
            },
            colors: [$danger],
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth',
                width: 2.5
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shadeIntensity: 0.9,
                    opacityFrom: 0.7,
                    opacityTo: 0.5,
                    stops: [0, 80, 100]
                }
            },
            series: [{
                name: $('[data-total_new_orders_label]').text(),
                data: [0,0,0,0,0,0,0]
            }],

            xaxis: {
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                }
            },
            yaxis: [{
                y: 0,
                offsetX: 0,
                offsetY: 0,
                padding: {left: 0, right: 0},
            }],
            tooltip: {
                x: {show: false},
                y: {
                    formatter: function(val) {
                        return parseInt(val)
                    }
                }
            },
            noData: {
                text: '...'
            },
        }

        var salesChart = new ApexCharts(
            document.querySelector("#line-area-chart-3"),
            salesChartoptions
        );

        salesChart.render();

        if ($('#line-area-chart-3').length) {
            fillChart(salesChart, $('#line-area-chart-3'), $('[data-total_new_orders]'), $('[data-total_new_orders_label]').text())
        }
    }

    // Order Received Chart
    // ----------------------------------
    if (document.querySelector("#line-area-chart-4")){
        var orderChartoptions = {
            chart: {
                height: 100,
                type: 'area',
                toolbar: {
                    show: false,
                },
                sparkline: {
                    enabled: true
                },
                grid: {
                    show: false,
                    padding: {
                        left: 0,
                        right: 0
                    }
                },
            },
            colors: [$warning],
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth',
                width: 2.5
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shadeIntensity: 0.9,
                    opacityFrom: 0.7,
                    opacityTo: 0.5,
                    stops: [0, 80, 100]
                }
            },
            series: [{
                name: 'Orders',
                data: [10, 15, 8, 15, 7, 12, 8]
            }],

            xaxis: {
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                }
            },
            yaxis: [{
                y: 0,
                offsetX: 0,
                offsetY: 0,
                padding: {left: 0, right: 0},
            }],
            tooltip: {
                x: {show: false},
                y: {
                    formatter: function(val) {
                        return parseInt(val)
                    }
                }
            },
            noData: {
                text: '...'
            },
        }

        var orderChart = new ApexCharts(
            document.querySelector("#line-area-chart-4"),
            orderChartoptions
        );

        orderChart.render();
    }

    // Site Traffic Chart
    // ----------------------------------
    if (document.querySelector("#line-area-chart-5")){
        var trafficChartoptions = {
            chart: {
                height: 100,
                type: 'line',
                dropShadow: {
                    enabled: true,
                    top: 5,
                    left: 0,
                    blur: 4,
                    opacity: 0.10,
                },
                toolbar: {
                    show: false,
                },
                sparkline: {
                    enabled: true
                },
                grid: {
                    show: false,
                    padding: {
                        left: 0,
                        right: 0
                    }
                },
            },
            colors: [$primary],
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth',
                width: 5
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shadeIntensity: 1,
                    gradientToColors: [$primary_light],
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 100, 100, 100]
                }
            },
            series: [{
                name: $('[data-total_preparing_orders_label]').text(),
                data: [0, 0, 0, 0, 0, 0, 0]
            }],

            xaxis: {
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                }
            },
            yaxis: [{
                y: 0,
                offsetX: 0,
                offsetY: 0,
                padding: {left: 0, right: 0},
            }],
            tooltip: {
                x: {show: false},
                y: {
                    formatter: function(val) {
                        return parseInt(val)
                    }
                }
            },
            noData: {
                text: '...'
            },
        }

        var trafficChart = new ApexCharts(
            document.querySelector("#line-area-chart-5"),
            trafficChartoptions
        );

        trafficChart.render();

        if ($('#line-area-chart-5').length) {
            fillChart(trafficChart, $('#line-area-chart-5'), $('[data-total_preparing_orders]'), $('[data-total_preparing_orders_label]').text())
        }
    }

    // Active Users Chart
    // ----------------------------------
    if (document.querySelector("#line-area-chart-6")){
        var userChartoptions = {
            chart: {
                height: 100,
                type: 'line',
                dropShadow: {
                    enabled: true,
                    top: 5,
                    left: 0,
                    blur: 4,
                    opacity: 0.10,
                },
                toolbar: {
                    show: false,
                },
                sparkline: {
                    enabled: true
                },
                grid: {
                    show: false,
                    padding: {
                        left: 0,
                        right: 0
                    }
                },
            },
            colors: [$success],
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth',
                width: 5
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shadeIntensity: 1,
                    gradientToColors: [$success_light],
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 100, 100, 100]
                }
            },
            series: [{
                name: $('[data-total_has_been_sent_orders_label]').text(),
                data: [0, 0, 0, 0, 0, 0, 0]
            }],

            xaxis: {
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                }
            },
            yaxis: [{
                y: 0,
                offsetX: 0,
                offsetY: 0,
                padding: {left: 0, right: 0},
            }],
            tooltip: {
                x: {show: false},
                y: {
                    formatter: function(val) {
                        return parseInt(val)
                    }
                }
            },
            noData: {
                text: '...'
            },
        }

        var userChart = new ApexCharts(
            document.querySelector("#line-area-chart-6"),
            userChartoptions
        );

        userChart.render();

        if ($('#line-area-chart-6').length) {
            fillChart(userChart, $('#line-area-chart-6'), $('[data-total_has_been_sent_orders]'), $('[data-total_has_been_sent_orders_label]').text())
        }
    }

    // News Letter Chart
    // ----------------------------------
    if (document.querySelector("#line-area-chart-7")){
        var newsletterChartoptions = {
            chart: {
                height: 100,
                type: 'line',
                dropShadow: {
                    enabled: true,
                    top: 5,
                    left: 0,
                    blur: 4,
                    opacity: 0.10,
                },
                toolbar: {
                    show: false,
                },
                sparkline: {
                    enabled: true
                },
                grid: {
                    show: false,
                    padding: {
                        left: 0,
                        right: 0
                    }
                },
            },
            colors: [$warning],
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth',
                width: 5
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shadeIntensity: 1,
                    gradientToColors: [$warning_light],
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 100, 100, 100]
                }
            },
            series: [{
                name: $('[data-total_orders_label]').text(),
                data: [0, 0, 0, 0, 0, 0, 0]
            }],

            xaxis: {
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                }
            },
            yaxis: [{
                y: 0,
                offsetX: 0,
                offsetY: 0,
                padding: {left: 0, right: 0},
            }],
            tooltip: {
                x: {show: false},
                y: {
                    formatter: function(val) {
                        return parseInt(val)
                    }
                }
            },
            noData: {
                text: '...'
            },
        }

        var newsletterChart = new ApexCharts(
            document.querySelector("#line-area-chart-7"),
            newsletterChartoptions
        );

        newsletterChart.render();

        if ($('#line-area-chart-7').length) {
            fillChart(newsletterChart, $('#line-area-chart-7'), $('[data-total_orders]'), $('[data-total_orders_label]').text())
        }
    }
});

function fillChart(chart_ref, el_chart, el_total, label){
    var dataKeys = el_chart[0].dataset,
        requestData = {};

    for (var dataKey in dataKeys) {
        if (dataKeys.hasOwnProperty(dataKey)) {
            requestData[dataKey] = el_chart[0].dataset[dataKey]
        }
    }

    $.ajax({
        type: "POST",
        url: requestData.endpoint,
        dataType: "json",
        data: requestData,
        success: function (data) {
            data.items = data.items.map(function (item) {
                return {
                    'x': item.created_at_date_only,
                    'y': item.count
                }
            });

            el_total.text(data.total + ' / ' + data.sum);

            chart_ref.updateSeries([{
                name: label,
                data: data.items
            }]);
        },
        error: function (data) {}
    });
}
